"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _badge = require("../../badge");

var _icons = require("../../icons");

var _text = require("../../text");

var _constants = require("../constants");

var _interfaces = require("../interfaces");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["badge", "children", "colorScheme", "icon", "iconPosition", "isSelected", "onClick", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var InteractiveChip = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var badge = _ref.badge,
      children = _ref.children,
      colorScheme = _ref.colorScheme,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick,
      size = _ref.size,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var isDefaultSize = size === _interfaces.ChipSize.Default;
  var hasLeadingIcon = !!icon && iconPosition === _interfaces.ChipIconPosition.Leading;
  var hasTrailingIcon = !!icon && iconPosition === _interfaces.ChipIconPosition.Trailing;
  var iconColorScheme = colorScheme;
  var badgeColorScheme = colorScheme === _interfaces.ChipColorScheme.DarkBackground ? _badge.BadgeColorScheme.DarkBackground : _badge.BadgeColorScheme.Default;

  if (isSelected) {
    badgeColorScheme = colorScheme === _interfaces.ChipColorScheme.DarkBackground ? _badge.BadgeColorScheme.Default : _badge.BadgeColorScheme.DarkBackground;
    iconColorScheme = colorScheme === _interfaces.ChipColorScheme.DarkBackground ? _interfaces.ChipColorScheme.Default : _interfaces.ChipColorScheme.DarkBackground;
  }

  var iconElement = !!icon ? /*#__PURE__*/_react.default.cloneElement(icon, {
    color: _constants.ICON_COLOR[iconColorScheme][_interfaces.ChipBackgroundColor.Default],
    size: _icons.IconSize.ExtraSmall
  }) : null;

  var renderChildren = function renderChildren() {
    return (0, _core.jsx)(_react.default.Fragment, null, hasLeadingIcon && iconElement, (0, _core.jsx)(_text.Text, {
      fontSize: isDefaultSize ? _constants.FONT_SIZE : _constants.FONT_SIZE_SMALL
    }, children), badge && (0, _core.jsx)(_badge.Badge, (0, _extends2.default)({
      colorScheme: badgeColorScheme
    }, badge)), hasTrailingIcon && iconElement);
  };

  var containerProps = _objectSpread({
    'aria-pressed': isSelected,
    colorScheme: colorScheme,
    isSelected: isSelected,
    onClick: onClick,
    ref: ref,
    size: size
  }, forwardedProps);

  return (0, _core.jsx)(_helperComponents.InteractiveChipContainer, containerProps, (0, _core.jsx)(_helperComponents.InteractiveChipInnerContainer, null, renderChildren()));
});
var _default = InteractiveChip;
exports.default = _default;